<script>
import moment from 'moment';

const getBadgeClass = function (days) {
    if (days <= 30) {
        return 'badge-success';
    }

    if (days <= 60) {
        return 'badge-warning';
    }

    if (days <= 90) {
        return 'badge-danger';
    }

    if (days <= 120) {
        return 'badge-secondary';
    }

    return 'badge-dark';
};

export default {
    name: 'DaysBadge',

    functional: true,

    props: {
        date: {
            type: String,
            default: null,
            validator: (value) => {
                if (!value || value.length === 0) {
                    return true;
                }

                return moment(value).isValid();
            },
        },
        none: {type: String, default: null},
        title: {type: String, default: null},
        append: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        const {directives = []} = data;

        if (!props.date || props.date.length === 0) {
            const nullLabel = props.none || parent.$t('common.days.unknown');

            return createElement(
                'span',
                {
                    staticClass: 'badge badge-danger text-nowrap',
                    attrs: {
                        ...data.attrs,
                        title: props.title,
                    },
                    directives: [
                        ...directives,
                        {name: 'tooltip'},
                    ],
                },
                [nullLabel],
            );
        }

        const pastDate = moment(props.date).format('YYYY-MM-DD');
        const currentDate = moment(new Date).format('YYYY-MM-DD');

        const days = moment(currentDate).diff(pastDate, 'days');
        const badgeClass = getBadgeClass(days);
        const badgeText = parent.$tc('common.days.count-today', days);

        return createElement(
            'span',
            {
                ...data,
                class: ['badge', badgeClass, data.staticClass, data.class],
                attrs: {
                    ...data.attrs,
                    title: props.title,
                },
                directives: [
                    ...directives,
                    {name: 'tooltip'},
                ],
            },
            [badgeText, props.append ? ` ${props.append}` : null],
        );
    },
};
</script>
